/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from '@/shared/api/axios-client'
import type { PostUsersAuthRefreshMutationResponse, PostUsersAuthRefresh400 } from '../entities/PostUsersAuthRefresh'
import type { RequestConfig, ResponseErrorConfig } from '@/shared/api/axios-client'

function getPostUsersAuthRefreshUrl() {
  return `/users/auth/refresh` as const
}

/**
 * @description Обновление токена
 * @summary Обновление токена
 * {@link /users/auth/refresh}
 */
export async function postUsersAuthRefresh(config: Partial<RequestConfig> & { client?: typeof client } = {}) {
  const { client: request = client, ...requestConfig } = config

  const res = await request<PostUsersAuthRefreshMutationResponse, ResponseErrorConfig<PostUsersAuthRefresh400>, unknown>({
    method: 'POST',
    url: getPostUsersAuthRefreshUrl().toString(),
    ...requestConfig,
  })
  return res.data
}